import React, {useState, useEffect} from 'react';
import {BrowserRouter} from 'react-router-dom';
import {useHistory} from 'react-router';
import {useDispatch, useSelector} from 'react-redux';
import actions from '../../../redux/actions';

const LocationRouter = ({initialRouting={}, byPassRoutes=[], newDesignRoutes=[], ...props}) => {
    const history = useHistory();
    const [loaded, setLoaded] = useState(false);
    const isLoggedIn = useSelector( (state) => state.login.isLoggedIn );
    const dispatch = useDispatch();

    useEffect(() => {
        const completeLocation = window.location.pathname;
        let location = window.location.pathname.split('/')[1];
        const token = window.location.pathname.split('/')[2];
        if ( newDesignRoutes.includes( completeLocation ) ) {
            history.replace( completeLocation );
        } else if ( !byPassRoutes.includes( location ) ) {
          location = initialRouting[location] ?? initialRouting['default'] ?? '/';
          history.replace(location);
        } else if (isLoggedIn && token) {
            dispatch(actions.login.logout());
            history.replace(window.location.pathname);
        } else if (isLoggedIn) {
            history.replace('/home');
        }
        setLoaded(true);
        // eslint-disable-next-line
    }, [] );

  return loaded && (<BrowserRouter {...props} />);
};

export default LocationRouter;
